import React from 'react';
import PropTypes from 'prop-types';
import styles from "../styles/components/StatusIndicator.module.css";

const StatusIndicator = ({ item }) => {
	let colorClass = styles.yellow;
	if(item.success){
		if(item.processing){
			// success but there is some character being generated
			colorClass = styles.gray;
		}else if(item.thumbnail){
			colorClass = styles.green;
		}else{
			colorClass = styles.red;
		}
	}else{
		if(item.processing){
			colorClass = styles.grey;
		}else{
			colorClass = styles.red;
		}
	}
	return (
		<div className={[styles.indicator, colorClass].join(' ')} />
	);
};

StatusIndicator.propTypes = {
	item: PropTypes.any.isRequired,
};

export default StatusIndicator;